import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const Sidebar = () => {
    const location = useLocation();

    const links = [
        { name: 'Home', path: '/' },
        { name: 'Privacy Policy', path: '/privacy-policy' },
        { name: 'Delete Account', path: '/delete-account' },
        { name: 'FAQ', path: '/faq' },
        { name: 'For Business', path: '/for-business' },
        { name: 'Contact', path: '/contact' },
    ];

    return (
        <div className="sidebar-container sticky-top" style={{ top: '20px', zIndex: 1 }}>
            <div className="card border shadow-sm rounded-4 bg-white overflow-hidden p-4">
                <h5 className="mb-4 fw-bold">Quick Links</h5>
                <nav>
                    <ul className="list-unstyled mb-0">
                        {links.map((link) => {
                            const isActive = location.pathname === link.path;
                            return (
                                <li key={link.path} className="mb-3">
                                    <Link
                                        to={link.path}
                                        className={`text-decoration-none d-block py-1 ${isActive
                                                ? 'text-primary fw-bold border-start border-4 border-primary ps-3'
                                                : 'text-dark ps-3'
                                            }`}
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default Sidebar;
